import { Link } from "react-router-dom";
import { leagues } from "@/mocks/leagues";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-white/75">
      <div className="w-full px-4 md:px-8 pt-12 md:pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center text-white">
                <i className="ri-football-fill text-xl" />
              </span>
              <span className="font-heading text-xl font-semibold text-white tracking-wide">
                51<span className="text-accent-500">足球</span>直播
              </span>
            </div>
            <p className="text-sm leading-relaxed text-white/60">
              51网站在线观看免费播播足球，专注提供高清、流畅、丰富的足球赛事直播与精彩回放，
              涵盖英超、西甲、欧冠、世界杯等多项热门赛事。
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm tracking-wide">快速导航</h3>
            <ul className="space-y-2.5 text-sm">
              {[
                { label: "首页", to: "/" },
                { label: "实时直播", to: "/live" },
                { label: "精彩回放", to: "/replay" },
                { label: "赛事解析", to: "/analysis" },
                { label: "关于我们", to: "/about" },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm tracking-wide">热门联赛</h3>
            <ul className="space-y-2.5 text-sm">
              {leagues.map((lg) => (
                <li key={lg.key}>
                  <Link
                    to={`/category/${lg.key}`}
                    className="hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {lg.name} 直播
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm tracking-wide">联系我们</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                <span>service@51football.demo</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-400" />
                <span>400-000-5151</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400" />
                <span>服务时间：9:00 - 24:00</span>
              </li>
            </ul>
            <div className="flex items-center gap-2 mt-4">
              {["ri-wechat-line", "ri-weibo-line", "ri-youtube-line", "ri-bilibili-line"].map(
                (icon) => (
                  <span
                    key={icon}
                    className="w-9 h-9 flex items-center justify-center rounded-md bg-white/10 hover:bg-accent-500 hover:text-white text-white/80 transition-colors cursor-pointer"
                  >
                    <i className={icon} />
                  </span>
                ),
              )}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© 2026 51网站在线观看免费播播足球 · 保留所有权利</p>
          <p>本站为演示性质内容展示平台，播放内容均为前端演示，不提供真实直播流。</p>
        </div>
      </div>
    </footer>
  );
}